<template>
    <div class='work-panel'>
        <div class="yc-wrap"  v-if="type === 'yc'">
            <div class="wk-header">
                <img class="avatar" onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'" 
                    v-bind:src="work.avatar.replace(/\.(jpg|png|gif)/, `.$1_160x162.$1`)" />
                <a class="ctrl-btn" href="javascript:;" v-bind:class="{ 'status-pause': playStatus === 1 }"  v-on:click="play"></a> 
                <span class="number">{{'No.' + work.sort_id }}</span>
            </div>
            <div class="wk-footer">
                <div class="song-name">
                    <a target="_blank" v-bind:href="work.music_address" >{{work.music_title}}</a>
                </div> 
                <div class="song-author">
                    上传：<a target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.uid+'/default.html'" >{{work.author}}</a>
                </div> 
                <div class="progress-bar">
                    <i v-bind:style="{ width: (work.vote_number >= 100000) ? '100%' : (work.vote_number/100000*100)+'%' }"></i>
                </div>
                <div class="vote-count">
                    <span>{{work.vote_number }}</span>票
                </div> 
                <div class="btns clearfix">  <!--  v-on:click="vote"-->
                    <a class="vote-btn"  href="javascript:;"  v-bind:class="{ 'disable': voteBtnStatus === 1 }" v-on:click="vote">+1票</a>
                    <a class="share-btn" href="javascript:;"  v-bind:class="{ 'disable': shareBtnStatus === 1 }" v-on:click="share">分享</a>
                </div>
            </div>
        </div>
        <div class="mv-wrap "  v-else-if="type === 'mv'">
             <div class="wk-header">
                <img class="avatar" onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'" 
                    v-bind:src="work.cover.replace(/\.(jpg|png|gif)/, `.$1_210x110.$1`)" />
                <a class="ctrl-btn" target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.userId+'/Video/'+work.mv_id+'.html'"></a> 
                <div class="number">
                    <span class='time' v-format="work.duration"></span>
                    <span class='play' >播放量：<span v-short="work.play"></span ></span>
                </div>
            </div>
            <div class="wk-footer">
                <div class="song-name">
                    <a target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.userId+'/Video/'+work.mv_id+'.html'">{{work.title}}</a>
                </div> 
                <div class="song-author">
                    上传：<a target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.userId+'/default.html'" >{{work.nickName}}</a>
                    <a class="share-btn" href="javascript:;"  v-on:click="share"><i></i>分享</a>
                </div> 
            </div>
        </div>
        <template v-else-if="type === 'winnerSong'">
            <div class='item-header'>
                
                <img  onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'" 
                    v-bind:src="work.singerUrl.replace(/\.(jpg|png|gif)/, `.$1_160x162.$1`)" />
                <!-- <img src="http://wsing.bssdl.kugou.com/db7d39f6047e2d2dd66a00d0762f0afb.jpg_160x160.jpg" alt=""> -->
                <span class='item-play'  v-bind:class="{ 'status-pause': playStatus === 1 }"  v-on:click="play"></span>
                <span class='item-icon' v-if="work.teamtype == 2"></span>
                <span class='item-icon item-icon-h' v-else-if="work.teamtype == 3"></span>
            </div>
            <span class='item-share'  v-on:click="share"></span>
            <a class='item-author' target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.singerId+'/default.html'" >{{work.singerName}}</a>
            <a class='item-name' target="_blank"  v-bind:href="work.songPcUrl">{{work.songName}}</a>
        </template>    
        <template v-else-if="type === 'winnerMv'">
            <img class="mv-img"  onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'" 
                    v-bind:src="work.cover.replace(/\.(jpg|png|gif)/, `.$1_175x145.$1`)" >
            <div class='mv-item'>
                <div class='item-head'>
                    <a class="mv-play" target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.userId+'/Video/'+work.mv_id+'.html'" ></a> 
                    <div class="number">
                        <span class='time' v-format="work.duration"></span>
                        <span class='play' >播放量：<span  v-short="work.play"></span ></span>
                    </div>
                </div>
                <div class='item-btm'>
                    <a class='mv-name' target="_blank"   v-bind:href="'http://5sing.kugou.com/'+work.userId+'/Video/'+work.mv_id+'.html'">{{work.title}}</a>
                    <a class='mv-auther' target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.userId+'/default.html'" >{{work.nickName}}</a>
                    <span class='mv-share' target="_blank" v-on:click="share"><i></i>分享</span>
                </div>
            </div>
        </template>   
        <div class="yc-wrap "  v-if="type === 'winner20'">
            <div class="wk-header">
                <img class="avatar" onerror="this.src='http://wsing.bssdl.kugou.com/83c672ae58e78605300845310eab1412.jpg'" 
                    v-bind:src="work.avatar.replace(/\.(jpg|png|gif)/, `.$1_190x162.$1`)" />
                <!-- <a class="ctrl-btn" href="javascript:;" v-bind:class="{ 'status-pause': playStatus === 1 }"  v-on:click="play"></a>  -->
                <span class='item-play'  v-bind:class="{ 'status-pause': playStatus === 1 }"  v-on:click="play"></span>
            </div>
            <div class="wk-footer">
                <div class="song-name">
                    <a target="_blank" v-bind:href="work.music_fc_address" >{{work.music_title}}</a>
                </div> 
                <div class="song-author">
                    上传：<a target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.uid+'/default.html'" >{{work.author}}</a>
                </div> 

                <div class="btns clearfix">  <!--  v-on:click="vote"-->
                    <a class="w-share" href="javascript:;"   v-on:click="share"></a>
                </div>
            </div>
        </div> 
        <template v-else-if="type === 'winner10'">
            <img  v-bind:src="'http://static.5sing.kugou.com/5sing/activity/mdkt2018/img/w10/'+work.team+'.png'" alt="">
            <div class='content'>
                <div class='head'>
                    <img v-bind:src="work.singerUrl.replace(/\.(jpg|png|gif)/, `.$1_90x60.$1`)"  alt="">
                    <span class='btn' v-bind:class="{ 'play': playStatus === 1 }"  v-on:click="play"></span>
                </div>
                <div class='txt'>
                    <a  class='txt-item'  target="_blank" v-bind:href="work.songPcUrl" >{{work.songName}}</a>
                    <a  class='txt-item' target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.singerId+'/default.html'" >{{work.singerName}}</a>
                    <!-- <p class='song'>爱在无风时</p>
                    <p class='name'>邵元</p> -->
                </div>
                
                <span class='share' v-on:click="share"></span>
            </div>
        </template>       
        <template v-else-if="type === 'wl'">

            <div class='content'>
                <div class='head' v-on:click="play">
                    <img v-bind:src="work.singerUrl"  alt="">
                    <span class='btn' v-bind:class="{ 'play': playStatus === 1 }"  ></span>
                </div>
                <div class='txt'>
                    <a  class='txt-item'  target="_blank" v-bind:href="work.songPcUrl" >{{work.songName}}</a>
                    <a  class='txt-item' target="_blank" v-bind:href="'http://5sing.kugou.com/'+work.singerId+'/default.html'"  v-html="work.singerName"></a>
                    <p v-html="work.txt"></p>
                </div>
                
                <span class='share' v-on:click="share"></span>
            </div>
        </template>  
    </div>
</template>
<script>
let captcha1 ;
export default {
    name: 'work',
    props:{
        winnerType: String,
        columnIndex: Number,
        work: Object
    },
    data () {
        return {
            shareConfig: this.$winConfig.shareConfig,
            type: this.winnerType?this.winnerType:this.$winConfig.signConfig[this.columnIndex].type,
            sid: this.$winConfig.signConfig[this.columnIndex].id,
            audioPlay: this.$audio,  //音频播放器
            playStatus: 0,           //0为暂停 1为播放
            voteBtnStatus: 0,
            shareBtnStatus: 0,
            //voteNumber: this.work.vote_number
        }
    },
    created () {
        var _this = this;
        if(_this.$audio.getPlayId() == _this.work.id  && _this.$audio.getPlayStatus() == 'play'){
            _this.playStatus = 1;
        }
        
    },
    watch:{
        work:function(){
            this.playStatus = 0;
            if(this.$audio.getPlayId() == this.work.id  && this.$audio.getPlayStatus() == 'play'){
                this.playStatus = 1;
            }
        }
    },
    mounted:function(){
        var _this = this;
        eventbus.$on("audioPlayer", function (res) {
            if(res.type == 'ended' || res.type == 'pause'){
                _this.playStatus = 0;
            }else if(res.type == 'play'){
                if(res.id == _this.work.id){
                    _this.playStatus = 1;
                }else{
                    _this.playStatus = 0;
                }
            }else if(res.type == 'error'){
                if(_this.playStatus == 1){
                    _this.playStatus = 0;
                    _this.$tipsBox.error({
                        message: "歌曲加载失败！",
                    });
                } 
            }
        });  
    },
    methods: {
        play: function(){
            var _this = this;
            if(_this.playStatus == 0){
                _this.playStatus = 1;
                eventbus.$emit("videoPlayer", 'pause');
                if(_this.$audio.getPlayId() != _this.work.id){
                    /**
                     * 请求歌曲资源。
                     * @param {string} id     歌曲id。
                     * @param {string} type   歌曲类型。
                     * @param {number} dateline  时间戳。
                     */
                    var formData = {
                        id: _this.work.mid, 
                        //type:  "fc" === _this.work.type ? 2 : "bz" === _this.work.type ? 3 : 1, 
                        type: _this.work.song_type? _this.work.song_type: "fc" === _this.work.type ? 2 : "bz" === _this.work.type ? 3 : 1,
                        dateline: new Date().getTime() 
                    };
                    _this.$server.getSongMsg(formData).then(function(res){
                        res = res.data;
                        _this.$audio.play({
                            src: res.data.FileName,
                            playId: _this.work.id
                        });
                    });
                }else{
                    _this.$audio.resPlay()
                }
                eventbus.$emit("audioPlayer", {type:'play', id: _this.work.id});
            }else{
                _this.playStatus = 0
                _this.$audio.pause();
                eventbus.$emit("audioPlayer", {type:'pause'});
            }
        },
        vote: function(){
            var _this = this;
            if(!this.$winConfig.isLogin){
                this.$tipsBox.error({
                    message: "请先登录",
                    reload: "http://5sing.kugou.com/login/"
                });
                return;
            }
            captcha1 = new TencentCaptcha('2046911983', function(res) {
                if(res.ret == 0){
                     /**
                     * 投票。
                     * @param {string} sid     报名id。
                     * @param {string} library
                     * @param {number} signup_id  作品ID。
                     */
                    var formData = {
                        sid:      _this.$winConfig.voteColumnId ,
                        library:   2,
                        signup_id: _this.work.id,
                        randstr : res.randstr,
                        ticket: res.ticket
                    };
                    _this.voteBtnStatus = 1;
                    _this.$server.vote(formData).then(function(res){
                        res = res.data;
                        if(res.status == 2){
                            _this.$tipsBox.error({
                                message: "请先登录",
                                reload: 'http://5sing.kugou.com/login/'
                            });
                        }else if (-1 !== res.message.indexOf("投票数已达到上限")){
                            _this.$tipsBox.error({
                                message: "投票次数已达上限，使用5sing手机端还可多投10票哦~！"
                            });
                        }else if(res.status == 1){
                            _this.work.vote_number++;
                            _this.$tipsBox.tips({
                                message: "投票成功！数据同步可能延迟，请耐心等待。"
                            });
                        }else{
                            _this.$tipsBox.error({
                                message: res.message
                            });
                        }
                        _this.voteBtnStatus = 0;
                        captcha1 = null;
                    }).catch(function(){
                        _this.$tipsBox.error({
                            message: "服务器开小差，请稍后再试..."
                        });
                        _this.voteBtnStatus = 0;
                        captcha1 = null;
                    });
                }else if(res.ret == 2){
                    captcha1 = null;
                }

            });
            captcha1.show(); 
            
        },
        share: function(){
            /**
             * 分享到5sing动态。
              * @param {string} desc     分享描述
              * @param {string} image    分享图
             */
            var _this = this;
            if(!this.$winConfig.isLogin){
                this.$tipsBox.error({
                    message: "请先登录",
                    reload: "http://5sing.kugou.com/login/"
                });
                return;
            }
            this.$tipsBox.confirm({
                message: "分享到5sing动态吗?",
                yes: '确定',
                no: '取消',
                sure: function(){
                    var formData = {
                        pic: _this.shareConfig.image,
                        text: decodeURIComponent(_this.shareConfig.description4Wsing),
                    };
                    _this.shareBtnStatus = 1;
                    this.$server.share(formData).then(function(res){
                        res = res.data;
                        if(1 === parseInt(res.code)){
                            _this.$tipsBox.error({
                                message: "请先登录",
                                reload: 'http://5sing.kugou.com/login/'
                            });
                        }else{
                            _this.$tipsBox.tips({
                                message: "分享成功！"
                            });
                        }
                        _this.shareBtnStatus = 0;
                    }).catch(function(){
                        _this.$tipsBox.error({
                            message: "服务器开小差，请稍后再试..."
                        });
                        _this.shareBtnStatus = 0;
                    });
                }
            });
        },
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.work-panel {
    display: inline-block;
    font-size: 14px;
    .avatar{
        display: block;
        width: 100%;
        height: 100%;
    }
    .number {
        position: absolute;
        right: 0;
        bottom: 0;
        display: block;
        color: #fff;
        font-size: 16px;
    }
    .ctrl-btn {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: none;
        background: url(componentsImgPath('work/19.png')) center no-repeat;
    }
    .ctrl-btn.status-pause {
        background: url(componentsImgPath('work/20.png')) center no-repeat;
    }
    .wk-header:hover .ctrl-btn{
        display: block;
    }

    .wk-footer {
        position: relative;
        padding: 10px;
        background-color: #fff;
    }
    .song-name {
        height: 43px;
        line-height: 1.5;
        margin-bottom: 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        a{
            display: block;
            color: #542eab;
        }
    }
    
    .progress-bar
    { 
        width: 140px;
        margin: 0 auto 8px;
        background-color: #e4e4e4;
        border-radius: 10px;
        overflow: hidden;
    }
    .progress-bar i 
    {
        display: block;
        height: 10px;
        background-color: #ff355b;
    }
    .vote-count 
    {
        margin-bottom: 8px;
        text-align: center;
        color: #333;
        span 
        {
            color: #ff355b;
            margin-right: 5px;
            font-size: 18px;
        }
    }
}

.yc-wrap{
    width: 160px;
    .wk-header{
        position: relative;
        height: 160px;
    }
    .number {
        width: 98px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: rgba(118, 88, 188,.7);
    }
    .song-author {
        margin-bottom: 8px;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #6d6d6d;
        a{
            color: #6d6d6d;
        }
    }
    .btns{
        text-align: center;
        a{
            display: inline-block;
            width: 65px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #fff;
            border-radius: 4px;
        }
        a.disable{
            background: #666;
            cursor: default;
        }
        .vote-btn{
            background-color: #ff3ab7;
            background-position: 0 0;
        }
        .share-btn {
            margin-left: 4px;
            background-color: #8757f4;;
            background-position: -66px 0;
        }
    }
}
.mv-wrap{
    width: 210px;
    .wk-header{
        position: relative;
        height: 110px;
    }
    .number {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        font-size: 0;
        background-color: rgba(0, 0, 0,.7);
        box-sizing: border-box;
        span{
            display: inline-block;
            font-size: 12px;
        }
        .time{
            width: 30%;
        }
        .play{
            width: 70%;
            text-align: right;
        }
    }
    .song-author {
        position: relative;
        margin-bottom: 8px;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #6d6d6d;
        a{
            color: #6d6d6d;
        }
        .share-btn{
            position:absolute;
            right: 0;
            display: inline-block;
            text-align: center;
            color: #542eab;
            i{
                display: inline-block;
                width: 13px;
                height: 14px;
                margin-right: 5px;
                vertical-align: middle;
                background: url(componentsImgPath('work/share.png')) center no-repeat;
            } 
        }
    }
    .ctrl-btn {
        background: url(componentsImgPath('work/video.png')) center no-repeat;
    }
    
}

</style>




// WEBPACK FOOTER //
// src/components/work-item.vue